import React from 'react'
import { StyledCustomCard } from './styles'

export const CustomCard = props => <StyledCustomCard {...props} />

CustomCard.defaultProps = {
  hoverable: true
}
